import { jsx as _jsx } from "react/jsx-runtime";
import { Button } from '../../../components/button/button';
export const SliderButtonStandAlone = (props) => {
    const variant = props.variant ?? props.styles?.variant;
    const size = props.size ?? props.styles?.size;
    if (!variant || !variant) {
        return null;
    }
    return (_jsx(Button, { ...props, size: size, variant: variant, children: props.content }));
};
//# sourceMappingURL=sliderButtonStandAlone.js.map